module.exports = __webpack_public_path__ + "img/movies-icon-active.d4314ef7.svg";